import { render } from "./FrontPage.vue?vue&type=template&id=4e2eb2cb&scoped=true"
import script from "./FrontPage.vue?vue&type=script&lang=js"
export * from "./FrontPage.vue?vue&type=script&lang=js"

import "./FrontPage.vue?vue&type=style&index=0&id=4e2eb2cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2eb2cb"]])

export default __exports__